import { render, staticRenderFns } from "./routes.vue?vue&type=template&id=51f3aab1&"
import script from "./routes.vue?vue&type=script&lang=js&"
export * from "./routes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51f3aab1')) {
      api.createRecord('51f3aab1', component.options)
    } else {
      api.reload('51f3aab1', component.options)
    }
    module.hot.accept("./routes.vue?vue&type=template&id=51f3aab1&", function () {
      api.rerender('51f3aab1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/add-routes/routes.vue"
export default component.exports